import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { EnvironmentProviders, Provider, inject, provideEnvironmentInitializer } from "@angular/core";
import { AuthService } from "shared-service/services/auth/auth.service";
import { authInterceptor } from "./auth.interceptor";
import { httpReliabilityInterceptor } from "../http/http-reliability.interceptor";

// Register the Initializer
export const provideAuth = (): Array<Provider | EnvironmentProviders> => {
    return [
        provideHttpClient(withInterceptors([authInterceptor, httpReliabilityInterceptor])),
        provideEnvironmentInitializer(() => inject(AuthService)),
    ];
};
